import { FETCH_FOOTER_DATA } from './constants'

const initialState = {
  footer: {},
  isFetching: false,
  error: {}
}

export default function reducer(state = initialState, action) {
  switch (action.type) {
    case FETCH_FOOTER_DATA['REQUEST']: {
      return {
        ...state,
        isFetching: true,
        footer: {}
      }
    }
    case FETCH_FOOTER_DATA['SUCCESS']: {
      return {
        ...state,
        isFetching: false,
        footer: action.footer
      }
    }
    case FETCH_FOOTER_DATA['FAILURE']: {
      return {
        ...state,
        isFetching: false,
        error: action.error
      }
    }
    default: {
      return state
    }
  }
}



// WEBPACK FOOTER //
// ./src/containers/Footer/reducer.js